const CommonServices = {
    subscribeNewsletter: async (email) => {
        const options = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            body: JSON.stringify({
                email,
            }),
        };

        try {
            const response = await fetch(
                'https://api-prod.ferventeshop.com/api/v2/meta/newsletter',
                options,
            );

            if (!response.ok) {
                throw new Error('Failed to subscribe to the newsletter');
            }

            const data = await response.json();
            return data;
        } catch (error) {
            return error;
        }
    },
};

export default CommonServices;
